import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';

export const coreComponentsTranslations = createTranslationResource({
  ref: coreComponentsTranslationRef,
  translations: {
    en: () => import('./core-components-en'),
    es: () => import('./core-components-es'),
  },
});